<template>
  <v-dialog
    v-model="dialog"
    persistent max-width="800"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        color="success"
      >
        Novo Município
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title">Cadastro de novo Município</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>Sobre o Município</h2>
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-project-combobox
              :filter="payload"
              @changeProject="loadGroupSolutions()"
              required
            ></app-project-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            md="2"
            sm="2"
            lg="2"
          >
            <v-text-field
              label="Código IBGE"
              name="CodigoIBGE"
              type="text"
              maxlength="6"
              required
              v-model="payload.CodigoIBGE"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            sm="6"
            lg="6"
          >
            <v-text-field
              label="Nome do município"
              name="nome"
              type="text"
              readonly
              v-model="payload.nome"
              @focus="loadName()"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <app-ur-combobox
              :filter="payload"
            ></app-ur-combobox>
          </v-col>
        </v-row>

        <v-row v-if="maisdados">
          <v-col
            md="6"
            sm="6"
            lg="6"
          >
            <v-text-field
              label="Prefeito"
              name="prefeito"
              type="text"
              required
              v-model="payload.prefeito"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            sm="6"
            lg="6"
          >
            <v-text-field
              label="Partido"
              name="partido"
              type="text"
              required
              v-model="payload.partido"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="maisdados">
          <v-col>
            <app-consultant-combobox
              :filter="payload"
            ></app-consultant-combobox>
          </v-col>

          <v-col v-if="estado === 'MS'">
            <app-analistas-combobox
              :filter="payload"
            ></app-analistas-combobox>
          </v-col>
          <v-col v-else>
            <app-ads-combobox
              :filter="payload"
            ></app-ads-combobox>
          </v-col>
        </v-row>

        <v-row v-if="maisdados">
          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="População"
              name="populacao"
              type="text"
              required
              v-model="payload.populacao"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
            v-if="estado !== 'BA'"
          >
            <v-text-field
              label="Orçamento"
              name="orcamento"
              type="text"
              required
              v-model="payload.orcamento"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
            v-if="estado === 'BA'"
          >
            <v-text-field
              label="ISDEL"
              name="isdel"
              type="text"
              required
              v-model="payload.isdel"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="IDH"
              name="idh"
              type="text"
              required
              v-model="payload.idh"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="maisdados">
          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="PIB"
              name="pib"
              type="text"
              required
              v-model="payload.pib"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="Densidade Demográfica"
              name="densidadeDemografica"
              type="text"
              required
              v-model="payload.densidadeDemografica"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="Renda Média da População"
              name="rendaMedia"
              type="text"
              required
              v-model="payload.rendaMedia"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="maisdados">
          <v-col
            md="4"
            sm="4"
            lg="4"
            v-if="estado !== 'BA'"
          >
            <v-text-field
              label="Receita"
              name="receita"
              type="text"
              required
              v-model="payload.receita"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
            v-if="estado === 'BA'"
          >
            <v-text-field
              label="Área KM²"
              name="area"
              type="text"
              required
              v-model="payload.area"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
            v-if="estado !== 'BA'"
          >
            <v-text-field
              label="Despesa"
              name="despesa"
              type="text"
              required
              v-model="payload.despesa"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
            v-if="estado === 'BA'"
          >
            <v-text-field
              label="Tempo média abertura de empresas"
              name="tempomedia"
              type="text"
              required
              v-model="payload.tempoMedio"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="Número de Empresas"
              name="numeroEmpresas"
              type="text"
              required
              v-model="payload.numeroEmpresas"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="estado !== 'BA' && maisdados">
          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="ME e EPP (N°)"
              name="me"
              type="text"
              required
              v-model="payload.me"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="MEI (N°)"
              name="mei"
              type="text"
              required
              v-model="payload.mei"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="MEI / Total (%)"
              name="totalMEI"
              type="text"
              required
              v-model="payload.totalMEI"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="estado !== 'BA' &&  maisdados">
          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="IGM"
              name="igm"
              type="text"
              required
              v-model="payload.igm"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="Link Google Maps"
              name="linkMaps"
              type="text"
              v-model="payload.linkMaps"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="estado === 'BA' &&  maisdados">
          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="IDEB"
              name="ideb"
              type="text"
              required
              v-model="payload.ideb"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="Nº Docentes Educação Infantil"
              name="docentesEF"
              type="text"
              required
              v-model="payload.docentesEF"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="4"
            lg="4"
          >
            <v-text-field
              label="Nº Alunos Educação Infantil"
              name="alunosEF"
              type="text"
              required
              v-model="payload.alunosEF"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="maisdados">
          <v-col>
            <v-divider></v-divider>
            <h2>Atividades Econômicas</h2>
            <h4>Selecione as opções que melhor representam as atividades econômicas do município</h4>
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row v-if="maisdados">
          <v-col
            md="2"
            sm="2"
            lg="2"
            v-for="activity in activities"
            v-bind:key="activity.atividadeId"
          >
            <v-row>
              <v-col
              >
                <v-checkbox
                  v-model="atividades"
                  :id="'atividade' + activity.atividadeId"
                  :label="activity.nome"
                  :item-text="activity.nome"
                  :item-name="activity.atividadeId"
                  :value="activity"
                  color="primary"
                  :return-object="true"
                >
                </v-checkbox>
              </v-col>
              <v-col
                class="text-center"
              >
                <v-icon
                  color="primary"
                  x-large
                >
                  {{ activity.icone }}
                </v-icon>
                <v-text-field
                  label="Percentual"
                  :id="'percentual' + activity.atividadeId"
                  type="text"
                  v-model="activity.percentual"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

<!--
  PARTE DE SELECIONAR GRUPOS DE SOLUÇÕES  -- VIDE FUNÇÃO loadGroupSolutions

        <v-row v-if="estado === 'SC' || estado === 'MS' || estado === 'SP'">
          <v-col>
            <v-divider></v-divider>
            <h2>Grupos de Soluções</h2>
            <h4>Selecione os grupos de soluções para adicionar no município</h4>
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row v-if="estado === 'SC' || estado === 'MS' || estado === 'SP'">
          <v-col
            v-for="municipioGrupoSolucao in payload.municipioTodosGruposSolucoes"
            v-bind:key="municipioGrupoSolucao.grupoSolucaoId"
          >
            <v-checkbox
              v-model="payload.municipioGruposSolucoes"
              :id="'grupo-solucao' + municipioGrupoSolucao.grupoSolucaoId"
              :label="municipioGrupoSolucao.nome"
              :item-name="municipioGrupoSolucao.grupoSolucaoId"
              :value="municipioGrupoSolucao"
              color="primary"
              :return-object="true"
            >
            </v-checkbox>
          </v-col>
        </v-row>
-->
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="info" outlined text @click="maisdados = !maisdados">Dados Complementares</v-btn>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityAPI, cityIBGEAPI } from '@/modules/city'
// import { cityGroupSolutionAPI } from '@/modules/city'
import { activityAPI } from './ActivityAPI'
import { mapActions, mapGetters } from 'vuex'
import { AppProjectCombobox } from '@/modules/project'
import { AppUrCombobox } from '@/modules/ur'
import { AppConsultantCombobox, AppAdsCombobox, AppAnalistasCombobox } from '@/modules/user'

export default {
  name: 'AppModalInsertCity',
  components: {
    AppProjectCombobox,
    AppConsultantCombobox,
    AppAdsCombobox,
    AppAnalistasCombobox,
    AppUrCombobox
  },
  data () {
    return {
      payload: {
        nome: null,
        atividades: [],
        municipioGruposSolucoes: [],
        municipioTodosGruposSolucoes: []
      },
      maisdados: false,
      dialog: false,
      activities: [],
      atividades: [],
      estado: this.$store.state.uf
    }
  },
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  created () {
    this.loadActivities()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadName () {
      cityIBGEAPI.getNome(this.estado, this.payload.CodigoIBGE)
        .then(resp => {
          this.payload.nome = resp.data.nomeMunicipio
        })
        .catch(resp => {
          this.$notification.error('Erro ao Buscar nome do Município')
        })
    },
    onConfirm () {
      this.setLoading(true)
      for (let i = 0; i < this.atividades.length; i++) {
        this.payload.atividades.push({ 'AtividadeId': this.atividades[i].atividadeId, 'Percentual': this.atividades[i].percentual })
      }

      this.payload.consultorId = this.payload.usuarioId

      cityAPI.create(this.payload)
        .then(resp => {
          this.dialog = false
          this.payload = {}
          this.payload.atividades = []
          this.$emit('save')
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao cadastrar município')
        })
    },
    loadActivities () {
      activityAPI.list()
        .then(resp => {
          this.activities = resp.data
        })
        .catch(resp => {
          this.$notification.error('Erro ao listar atividades')
        })
    },
    loadGroupSolutions () {
    /*  this.setLoading(true)

      cityGroupSolutionAPI.getByProject(this.payload.projetoId)
        .then(resp => {
          this.payload.municipioTodosGruposSolucoes = resp.data
          this.payload.municipioGruposSolucoes = resp.data.filter(item => item.selecionada)
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao listar grupos de soluções')
        })
    */
    }
  }
}
</script>
